/**
 * 顶部操作事件类型
 * @type {string}
 */

export const INIT_OPERATION = "INIT_OPERATION" // 初始化操作按钮
export const ENABLE_OPERATION_ACTIVE = "ENABLE_OPERATION_ACTIVE" // 激活
export const DISABLE_OPERATION_ACTIVE = "DISABLE_OPERATION_ACTIVE" // 取消激活
export const HISTORY_HOVER = "HISTORY_HOVER" //  历史记录hover
export const HISTORY_CLICK = "HISTORY_CLICK" // 历史记录click
export const NEXT_STEP = "NEXT_STEP" // 下一步
export const PREVIOUS_STEP = "PREVIOUS_STEP" // 上一步
export const SAVE = "SAVE" // 保存
export const PREVIEW = "preview" // 预览
export const SET_ACTIVE_STATU = "SET_ACTIVE_STATU" // 预览

export default {
  INIT_OPERATION,
  ENABLE_OPERATION_ACTIVE,
  DISABLE_OPERATION_ACTIVE,
  HISTORY_HOVER,
  HISTORY_CLICK,
  NEXT_STEP,
  PREVIOUS_STEP,
  SAVE,
  PREVIEW,
  SET_ACTIVE_STATU
}
